import React, { useState } from 'react';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

/**
 * V2 password input with show/hide toggle.
 * Native input + circular icon button overlay so the styling matches
 * the rest of the auth form (no antd Input chrome).
 */
export default function PasswordField(props) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOutlined : EyeInvisibleOutlined;
  const { className, ...rest } = props;
  return (
    <div className="auth-input-wrap">
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        className={`auth-input ${className || ''}`}
      />
      <button
        type="button"
        className="auth-input-eye"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        <Icon />
      </button>
    </div>
  );
}

PasswordField.defaultProps = {
  autoComplete: 'current-password',
};
